var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_4181)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16675 7.50033C4.16675 4.27533 6.77508 1.66699 10.0001 1.66699C13.2251 1.66699 15.8334 4.27533 15.8334 7.50033C15.8334 11.8753 10.0001 18.3337 10.0001 18.3337C10.0001 18.3337 4.16675 11.8753 4.16675 7.50033ZM11.3563 8.03177H11.7176L14.0001 10.3188L13.3186 11.0003L11.0315 8.71788V8.35653L10.908 8.22846C10.3866 8.67671 9.70963 8.94658 8.97321 8.94658C8.38518 8.94658 7.81036 8.77221 7.32143 8.44552C6.8325 8.11883 6.45143 7.65449 6.2264 7.11122C6.00137 6.56796 5.94249 5.97016 6.05721 5.39343C6.17193 4.8167 6.45509 4.28694 6.87089 3.87114C7.28669 3.45534 7.81645 3.17218 8.39318 3.05746C8.96991 2.94274 9.56771 3.00162 10.111 3.22665C10.6542 3.45167 11.1186 3.83275 11.4453 4.32168C11.772 4.8106 11.9463 5.38543 11.9463 5.97346C11.9468 6.68366 11.692 7.37038 11.2282 7.90828L11.3563 8.03177Z",
    fill: "#E86D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_4181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSearch);
export default __webpack_public_path__ + "static/media/marker-search.56674d8c4fa29c3e433b49ca9105d8d8.svg";
export { ForwardRef as ReactComponent };